/** Alan uzunlukları ve iş kuralı sınırları — Joi şemaları ve DB kısıtları aynı değeri kullanır. */
export const FIELD_LIMITS = {
    email: { max: 254 },
    displayName: { min: 2, max: 80 },
    headline: { max: 120 },
    bio: { max: 600 },
    slug: { min: 3, max: 120 },
    eventTitle: { min: 3, max: 160 },
    eventSummary: { max: 300 },
    eventDescription: { max: 20000 },
    venueName: { max: 200 },
    addressLine: { max: 300 },
    /** "Haritada bul" sorgusu (harita Story 1): tek arama, 3-255 karakter. */
    venueSearchQuery: { min: 3, max: 255 },
    city: { max: 120 },
    /** Kurum künyesindeki serbest şehir adı (organizatör sayfası, 14.10.2026). */
    organizationCity: { max: 80 },
    countryCode: { length: 2 },
    url: { max: 2048 },
    phone: { max: 32 },
    companyName: { max: 160 },
    jobTitle: { max: 160 },
    /** Profesyonel profil — eğitim (Blok 8-1). Kıdem ve sektör kapalı listedir, uzunluk sınırı yok. */
    educationSchool: { max: 160 },
    educationField: { max: 160 },
    ticketTypeName: { min: 1, max: 80 },
    note: { max: 1000 },
    /** Başvuru notu — Story 5.2 kabul kriteri: en fazla 500 karakter. */
    applicationAnswer: { max: 500 },
    reason: { max: 2000 },
    /**
     * Görüşme talebi mesajı — Story 12.1 kabul kriteri: en fazla 500 karakter
     * ("bir cümlede yazın"). DB kolonu da 500'dür (Blok 11 migration).
     */
    meetingMessage: { max: 500 },
    /** Organizatörün tanımladığı görüşme alanı adı (D6 — serbest metin konum yok). */
    meetingAreaName: { max: 80 },
    /**
     * Personelin kurum kapağını panelden kaldırma gerekçesi (kurum kapağı · Story P1).
     * Kredi ters kaydı gerekçesiyle aynı tavan; deftere metin değil özet girer.
     */
    coverRemovalReason: { min: 1, max: 500 },
    tagSlug: { min: 2, max: 60 },
    tagLabel: { min: 2, max: 80 },
    /**
     * ÜRÜN UYGULAMASI ŞİFRESİ (kullanıcı kararı 05.09.2026 · K1).
     *
     * TABAN 8 — personel panelinin 12'sinden AYRI ve bilinçli olarak daha düşük.
     * Panel bir personel yüzeyidir ve az sayıda kişiyi ilgilendirir; ürün tüketici
     * yüzeyidir ve bileşim kuralları orada terk üretir (NIST SP 800-63B: uzunluk
     * tek kural). PANEL KİMLİK AYRIMINDAN SONRA iki politika yalnız ayrı şemada
     * değil AYRI PAKET KLASÖRÜNDE durur: ürününki burada
     * (`contracts/auth.ts::productPasswordSchema`), personelinki
     * `staff/staff-contracts.ts::staffPasswordSchema` — birini gevşetmek
     * diğerine hiç değmez.
     *
     * TAVAN 128 panelle AYNI: argon2 maliyeti girdi uzunluğuyla artar.
     */
    productPassword: { min: 8, max: 128 },
};
export const BUSINESS_LIMITS = {
    /** Bir kullanıcının sahip olabileceği kart sayısı (Faz 1 arayüzü tek kart gösterir). */
    maxCardsPerUser: 10,
    /** Bir etkinliğin bilet türü sayısı. */
    maxTicketTypesPerEvent: 20,
    /** Profil ilgi etiketi sayısı — Story 2.1 kabul kriteri: en az 1, en fazla 10. */
    maxInterestTagsPerUser: 10,
    /**
     * Mezuniyet yılı aralığı (Blok 8-1). Sabit sınır: Joi ile DB CHECK
     * (`ck_cards_graduation_year`) AYNI değeri kullanır — çalışma zamanına bağlı bir
     * üst sınır ikisini ayrıştırır ve şemayı takvime bağımlı kılardı. Devam eden
     * eğitim için ileri yıl serbesttir; daraltma arayüz tarafının işidir.
     */
    minGraduationYear: 1950,
    maxGraduationYear: 2100,
    /** Etkinlik ilgi etiketi sayısı — en az 1 zorunlu (Story 10.1). */
    minInterestTagsPerEvent: 1,
    maxInterestTagsPerEvent: 10,
    /** Davet geçerlilik süresi (gün). */
    invitationExpiryDays: 14,
    /** Tek toplu davet isteğinde en fazla e-posta (Story 5.3). */
    maxInvitationsPerBatch: 500,
    /**
     * Reddedilen başvurunun saklama süresi (gün) — süre dolunca başvuru verisi
     * (not dahil) kalıcı silinir; veri minimizasyonu (Story 5.2 devri).
     */
    rejectedApplicationRetentionDays: 30,
    /**
     * Uygulama içi bildirim kaydının saklama süresi (gün). Bildirim bir DEFTER
     * değil bir AKIŞTIR: 90 günden eski satır kullanıcıya bir şey söylemez ama
     * tabloyu ve sayaç sorgusunu şişirir (veri minimizasyonu).
     */
    notificationRecordRetentionDays: 90,
    /** Sahiplenme itiraz süresi (gün) — Story 3.5. */
    claimObjectionWindowDays: 7,
    /** OTP (Story 1.1): 6 haneli, 10 dakika geçerli, tek kullanımlık, 5 hatalı denemede iptal. */
    otpCodeLength: 6,
    otpTtlMinutes: 10,
    otpMaxAttempts: 5,
    /** Yeniden kod isteme penceresi — kullanıcıya gösterilen sayaç bununla uyumludur. */
    otpResendCooldownSeconds: 60,
    /**
     * ONAYLANMAMIŞ KAYDIN SAKLAMA SÜRESİ (gün) — kullanıcı kararı 05.09.2026 · K9.
     *
     * Kayıt açılır ama e-posta onaylanmazsa satır SARKAN KİŞİSEL VERİDİR (KVKK):
     * kimsenin kullanmadığı bir adres bizde süresiz durmaz. Yedi gün, kodun 10
     * dakikalık ömrünün çok üstünde bir "aklıma sonra gelir" penceresi bırakır ve
     * kod yeniden istenebilir; süre dolunca hesap bakım hattında temizlenir ve
     * adres yeniden kayda açılır.
     */
    unconfirmedAccountRetentionDays: 7,
    /**
     * Refresh rotasyonunda çift-sekme yarışı için idempotent pay penceresi (saniye).
     * Bu pencere içinde önceki jeton yeniden sunulursa çalınma sayılmaz; mevcut aile
     * yaşatılır. Pencere DIŞINDA katı iptal korunur (security-engineer Blok 2).
     */
    refreshReuseGraceSeconds: 10,
    /** Bir kullanıcının aynı anda açık tutabileceği oturum sayısı (cihaz). */
    maxActiveSessionsPerUser: 20,
    /** Sayfalama. */
    defaultPageSize: 20,
    maxPageSize: 100,
    /** "Haritada bul" en çok bu kadar sonuç döner (harita Story 1, K4). */
    venueSearchMaxResults: 5,
    /** Hesap silme geri alma penceresi (gün) — Story 8.4. */
    accountDeletionGraceDays: 14,
    /** Veri dışa aktarma bağlantısının geçerlilik süresi (saat) — Story 8.3. */
    dataExportLinkTtlHours: 24,
    /** Bir oturuma bağlanabilecek konuşmacı sayısı (Story 6.2). */
    maxSpeakersPerSession: 20,
    /**
     * Analitik kırılımlarının açılması için gereken en az kayıt sayısı
     * (k-anonimlik eşiği — ekran 21). Bu sayının altında sektör/kıdem yüzdesi
     * tek kişinin kart verisini ifşa eder, bu yüzden kırılım bastırılır.
     */
    analyticsMinBucketSize: 5,
    /**
     * Etkinlik sonu raporunun bitişten kaç gün sonra dondurulacağı (25.10.2026): anket
     * kapanışıyla AYNI an (`EVENT_SURVEY_LIMITS.closeAfterEndDays`, eşitliği
     * `event-report-ready.spec` asertler).
     */
    eventReportFreezeDays: 14,
    /** Tek istekte toplu işlem uygulanabilecek en fazla kayıt (ekran 19). */
    maxBulkAttendeeActions: 100,
    /**
     * Public etkinlik sayfasının sağ rayındaki "Benzer etkinlikler" satır sayısı.
     * Referans (`Public - Akış B` 225) üç satır çizer; ray 348px olduğu için
     * dördüncü satır kayıt kutusunu ekranın dışına itiyor.
     */
    maxSimilarPublicEvents: 3,
    // --- Öneri motoru (Blok 9-1) ---------------------------------------------
    /** Bir kullanıcı için saklanan en fazla etkinlik önerisi (gece işi bu kadar yazar). */
    maxStoredEventRecommendations: 30,
    /** Bir (kullanıcı, etkinlik) çifti için saklanan en fazla kişi önerisi. */
    maxStoredPersonRecommendations: 20,
    /** Okuma ucunun tek istekte dönebileceği en fazla öneri. */
    maxRecommendationPageSize: 30,
    /**
     * Gerekçede KİŞİ SAYISI yazabilmek için gereken en az kesişim (k-anonimlik).
     * Altında kalan kesişim (1-2 kişi) yalnızca herkesin görünürlüğü açıksa
     * yazılır; aksi halde gerekçe ETİKET üzerinden verilir — "X'teki 1 kişi buraya
     * da kayıtlı" cümlesi tek bir kişinin katılımını ifşa eder.
     */
    recommendationMinCohortSize: 3,
    /**
     * Anlamsal etiket yakınlığı TABANI (kosinüs). Değer ÖLÇÜLEREK seçildi,
     * yuvarlak sayı olduğu için değil: `paraphrase-multilingual-MiniLM-L12-v2`
     * ile 20 etiketin 190 çiftinde yakınlıklar 0,03–0,74 bandına yayılıyor ve
     * anlamlı komşular (finans↔yatırım 0,61 · pazarlama↔satış 0,74 ·
     * yapay zekâ↔veri 0,45) 0,40'ın üstünde, gürültü altında kalıyor.
     * 0,55 denendi: yapay zekâ↔veri gibi doğru çiftleri de eliyordu.
     * Taban tek başına yetmez — üretim script'i etiket başına en fazla 3 komşu
     * saklar (`EMBED_TOP_K`), böylece geniş bir etiket tüm tabloyu doldurmaz.
     */
    tagSimilarityThreshold: 0.4,
    /**
     * Etkinlik ilgi sinyalinin saklama süresi (gün). Kimin neye baktığı hassas
     * veridir: motorun ihtiyacı yakın geçmiştir, süresiz arşiv değil.
     */
    interestSignalRetentionDays: 180,
    /** Motorun "yakın geçmiş" penceresi (gün) — ilgi sinyali bu pencereden okunur. */
    interestSignalWindowDays: 30,
    /**
     * ÖNERİ TELEMETRİSİ SAKLAMA SÜRELERİ (öneri motoru Blok 1, kapsam belgesi 3.4,
     * kullanıcı onayı 17.09.2026). İki katman, iki süre:
     * - İsimsiz sayaçlar (`recommendation_impressions`,
     *   `recommendation_list_impressions`): kişisel veri değil. Mevsimsel
     *   karşılaştırma ("geçen yılın aynı ayı") iki yıl ister; sınırsız
     *   bırakılmaz, tablo büyür ve panel sorgusu yavaşlar.
     * - Kişi bazlı satırlar (`recommendation_user_events`): ilgi sinyaliyle AYNI
     *   süre (`interestSignalRetentionDays`). Aynı sınıf veri, aynı rıza, aynı
     *   aydınlatma metni; iki farklı süre kullanıcıya açıklanamaz.
     * Gece 02:50 penceresinde süpürülür (`recommendations.scheduler.ts`).
     */
    recommendationImpressionRetentionDays: 730,
    recommendationUserEventRetentionDays: 180,
    /**
     * GÖSTERİM JETONUNUN ÖMRÜ (saniye) — Story 2. Okuma ucu listeyle birlikte
     * sunucu tarafında saklanan bir jeton döner; istemci `viewed`/`opened`
     * olayını bu jetonla bildirir ve boyutlar (sıra, gerekçe, kol, kaynak)
     * jetondan çözülür. Liste ekranda uzun kalabilir (mobil ana sayfa), bu yüzden
     * ömür bir gündür: gece işi yeni liste yazınca eski jeton zaten anlamsızdır.
     * Süresi geçen jetonla gelen olay YAZILMAZ, yanıt yine 200 (kriter 10).
     */
    recommendationImpressionTokenTtlSeconds: 86_400,
    /** Tek telemetri isteğinde en fazla olay (kapsam belgesi 5.2). */
    maxRecommendationTelemetryEvents: 50,
    /**
     * GÖSTERİM EŞİĞİ (kapsam belgesi 3.2, kriter 14) — Story 3/4. Bir öğe
     * "görüldü" sayılır: en az YARISI, KESİNTİSİZ en az bir saniye ekranda.
     * Web (`IntersectionObserver`) ve mobil AYNI iki sayıyı BURADAN okur; ikinci
     * bir tanım `recommendation-surface.guard.spec` ile kırılır. Eşiğin
     * altına inen ya da arka plana alınan sekmede sayaç sıfırdan başlar.
     */
    recommendationViewThresholdRatio: 0.5,
    recommendationViewDwellMs: 1000,
    /**
     * Kişi önerisi hesaplanacak etkinlikte en fazla görünür katılımcı. Üstünde
     * aday çifti sayısı karesel büyür; büyük etkinlikler atlanır ve loglanır
     * (uydurma sonuç yerine eksik sonuç — hangisi olduğu defterde durur).
     */
    maxPersonRecommendationEventSize: 2000,
    /**
     * Sağlık yüzeyinin "bayat" eşiği (saat). Gece işi 03:20'de koşar; 24 saatten
     * uzun süredir BAŞARILI koşu yoksa öneriler sessizce eskiyor demektir
     * (Story 32.2 kabul kriteri).
     */
    recommendationRunStaleHours: 24,
    /**
     * Gece işinin süre uyarı eşiği (ms). Koşu bundan uzun sürerse işçi `warn`
     * yazar (öneri motoru Blok 1 · Story 6, E3 notu): 03:20'de başlayan iş sabah
     * trafiğine sarkmadan bitmelidir. Uyarı koşuyu DURDURMAZ, yalnız görünür kılar.
     */
    recommendationRunSlowWarnMs: 20 * 60 * 1000,
    /** Öneri → görüşme talebi dönüşümünün raporlandığı pencere (gün). */
    recommendationAttributionWindowDays: 30,
    // --- Görüşme talebi (Faz 2 / Blok 11) ------------------------------------
    /**
     * Bir kullanıcının TEK etkinlikte aynı anda açık tutabileceği talep sayısı
     * (Story 12.4 tavanı). Taciz yüzeyini daraltır: 200 kişilik salonda tek kişi
     * herkese yazamaz. Meşru kullanımı engellemez — kabul/ret/iptal sayacı boşaltır.
     */
    maxOpenMeetingRequestsPerEvent: 10,
    // --- Kurum doğrulama (Karar 1 / Blok 17C) --------------------------------
    /**
     * Yetki belgesi karardan bu kadar gün sonra R2'den SİLİNİR (KÇ 5; ekranda
     * yazan söz gerçekten uygulanır). Kurum sahibi silmeyi erkene alabilir.
     */
    organizationVerificationDocumentRetentionDays: 90,
    // --- Satış başvurusu (kurum satışla açılır · Story B1, K8) ---------------
    /**
     * Müşteriye dönüşmeyen başvuru, başvuru TARİHİNDEN bu kadar ay sonra
     * anonimleşir (kullanıcı kararı 01.10.2026). Kuruma bağlanan başvuru bu
     * süreye tabi değildir (V13).
     */
    salesInquiryRetentionMonths: 12,
};
/** Medya kuralları (Story 0.7). Sunucu tarafı içerik tipi doğrulaması bunu kullanır. */
export const MEDIA_RULES = {
    allowedMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
    /*
     * GÖRSEL ÜST SINIRI 5 MB (kullanıcı kararı 08.09.2026, önceden 10 MB).
     * Gerekçe faturalandırma yüzeyini daraltmak: yükleme ucu kimlik ve hız
     * sınırı istese de, kabul edilen her bayt depolama ve işlem maliyetidir.
     * Belge sınırı (`documentMaxBytes`) zaten 5 MB'tı; ikisi artık eşit.
     */
    maxBytes: 5 * 1024 * 1024,
    /**
     * Belge türü medya (Story 3.5 — sahiplenme yetki belgesi): yalnızca PDF, 5 MB.
     * Görsel işleme kuyruğuna GİRMEZ; tür bazlı kural `rulesForMediaKind` ile uygulanır.
     */
    documentKinds: ['claim_document', 'organization_document'],
    documentMimeTypes: ['application/pdf'],
    documentMaxBytes: 5 * 1024 * 1024,
    /**
     * DOSYA İMZASI (magic byte). Beyan edilen Content-Type İSTEMCİNİN sözüdür:
     * imzalı PUT'ta dosyayı gönderen taraf başlığı serbestçe yazar. Sunucu
     * `completeUpload`'da ilk baytları okur ve imza tutmuyorsa yüklemeyi düşürür
     * (Blok 17C fix, Orta-5).
     */
    documentMagicBytes: '%PDF-',
    /**
     * GÖRSEL DOSYA İMZASI — İLK SÜZGEÇ, TEK SÜZGEÇ DEĞİL.
     *
     * 15.09.2026–17.10.2026 arası türev hazır olana kadar özgün nesne public
     * servis ediliyordu (geçici sözlük) ve bu kontrol onun güvencesiydi: imzalı
     * PUT'un `Content-Type` başlığını İSTEMCİ yazar, "image/png" diyen bir HTML
     * dosyası barındırılabilirdi. Sihirli bayt tek başına yetmedi (JPEG imzası +
     * HTML gövdesi geçti, `guv-medya` QA P2); geçici sözlük kaldırıldı ve adres
     * artık yalnız sharp'tan geçmiş (`ready`) görselin türevine üretilir.
     *
     * Belgede (`documentMagicBytes`) zaten uygulanan kontrol görsele de genişler:
     * ilk baytlar okunur, imza tutmazsa yükleme DÜŞER. Anahtarlar
     * `allowedMimeTypes` ile BİREBİR olmak zorundadır (kapı sayar) — yeni bir
     * görsel tipi imzasız eklenemez.
     */
    imageMagicBytes: {
        'image/jpeg': [{ offset: 0, bytes: 'ffd8ff' }],
        'image/png': [{ offset: 0, bytes: '89504e470d0a1a0a' }],
        // WebP bir RIFF kabıdır: "RIFF" + 4 bayt uzunluk + "WEBP".
        'image/webp': [
            { offset: 0, bytes: '52494646' },
            { offset: 8, bytes: '57454250' },
        ],
    },
    /**
     * MARKA LOGOSU ASGARİ ÖLÇÜLERİ — İKİ AYRI KURAL, tek kurala İNDİRGENMEZ.
     *
     * Devir paketinde iki farklı alan çizilidir ve ölçüleri çelişir gibi görünür
     * (backlog §1 "ölçü çelişkisi" uyarısı):
     *  - `organization_logo` → **256×256 KARE** (kurum formu, satır 401). Kurum
     *    logosu monogram fallback'li bir kimlik damgasıdır; kare alandır.
     *  - `event_logo` → **240×80 YATAY BANT** (ekran 23 bölüm 3). Etkinlik logosu
     *    yaka kartının üst bandına oturur; kare değildir.
     *
     * İkisi AYNI ALAN DEĞİLDİR: tek bir "en az 256×256" kuralı yazılırsa geçerli
     * bir etkinlik bandı (240×80) reddedilir, tek bir "en az 240×80" kuralı
     * yazılırsa bulanık bir kurum logosu (240×80) kabul edilir.
     */
    minLogoDimensions: {
        organization_logo: { width: 256, height: 256 },
        event_logo: { width: 240, height: 80 },
    },
    /**
     * KURUM KAPAK GÖRSELİ ÖLÇÜLERİ (14.10.2026, organizatör sayfası v3).
     *
     * Logo değildir, AYRI tablodadır: logo kuralı (`minLogoDimensions`) mobilde
     * kırpma çıktısını ve şeffaflık kararını da belirliyor; kapak fotoğraftır.
     *  - Önerilen 2400×720 (tasarım kararı "Kapak oranı": masaüstü 3,25:1,
     *    1116 px rayı 2x ekranda doldurur). Yardım metni bu sayıyı buradan okur.
     *  - Asgari 1200×360: önerilenin yarısı. 1x ekranda rayı (1116×343) büyütmeden
     *    doldurur. Sunucu ölçer, küçükse reddeder (logo emsali).
     */
    minCoverDimensions: {
        organization_cover: { width: 1200, height: 360 },
    },
    recommendedCoverDimensions: {
        organization_cover: { width: 2400, height: 720 },
    },
    /**
     * Türev görsel boyutları — liste küçük resmi, detay, OG paylaşım görseli. HER görsel
     * türünde üretilir; türe bağlı ekler `media-variants.ts` (`MEDIA_KIND_VARIANTS`).
     */
    variants: {
        thumbnail: { width: 256, height: 256, fit: 'cover' },
        detail: { width: 1280, height: 720, fit: 'inside' },
        og: { width: 1200, height: 630, fit: 'cover' },
    },
};
/**
 * Bayt → MB. Ekranların "en çok N MB" cümlesi ve yükleme ilerlemesi bu tek
 * çeviriden geçer; istemcilerde `1024 * 1024` ELLE yazılmaz (mobilde o sayı
 * kırılım eşiği tarayan kapıya da takılıyordu).
 */
export function megabytesOf(bytes) {
    return bytes / (1024 * 1024);
}
/**
 * DOSYA BOYUTUNUN BİRİMİ — 1 MB ALTINDA KB (cihaz kanıtında ölçüldü).
 *
 * Kırpılmış bir logo 29 KB çıkabiliyor ve "0 MB" yazan bir ilerleme satırı
 * kullanıcıya hiçbir şey söylemiyordu (referansın 3. adımı "1,4 MB" yazıyor,
 * yani birim ANLAMLI olmak zorunda). Karar tek yerde: çağıran birim seçmez.
 */
export function byteScale(bytes) {
    const megabytes = megabytesOf(bytes);
    if (megabytes >= 1)
        return { value: megabytes, unit: 'MB' };
    return { value: bytes / 1024, unit: 'KB' };
}
/**
 * Kabul edilen dosya uzantılarının İNSAN OKUR listesi ("PNG · WebP · JPEG").
 *
 * Ekranın `accept` özniteliği ve altındaki cümle AYNI kaynaktan beslenir
 * (tech-lead DÜŞÜK): metin "PNG veya WebP" derken sunucu JPEG'i de kabul
 * ediyordu — söz ile davranış ayrışıyordu.
 */
export function acceptedImageLabels(kind) {
    return rulesForMediaKind(kind).allowedMimeTypes.map((mime) => (mime.split('/')[1] ?? mime).toUpperCase());
}
/**
 * Marka logosu asgari ölçüsü — tür bazında. Kural yoksa `null` döner (ölçü
 * denetimi o tür için yapılmaz). TEK KAYNAK: hem sunucu doğrulaması hem de
 * ekrandaki "en az …" cümlesi buradan okur.
 */
export function minLogoDimensionsForMediaKind(kind) {
    const rules = MEDIA_RULES.minLogoDimensions;
    return rules[kind] ?? null;
}
/** Kapak görseli asgari ölçüsü — tür bazında; kural yoksa `null`. */
export function minCoverDimensionsForMediaKind(kind) {
    const rules = MEDIA_RULES.minCoverDimensions;
    return rules[kind] ?? null;
}
/** Kapak görseli önerilen ölçüsü (yardım metni); kural yoksa `null`. */
export function recommendedCoverDimensionsForMediaKind(kind) {
    const rules = MEDIA_RULES.recommendedCoverDimensions;
    return rules[kind] ?? null;
}
/**
 * SUNUCUNUN ÖLÇÜ KAPISININ TEK SORUSU: bu türün asgari ölçüsü ne? Logo ve kapak
 * tabloları ayrı durur, kapı ikisini birden sorar (bir tür iki tabloda olamaz,
 * `media-dimension-rules.spec` sayar).
 */
export function minDimensionsForMediaKind(kind) {
    return minLogoDimensionsForMediaKind(kind) ?? minCoverDimensionsForMediaKind(kind);
}
/**
 * BELGE TÜRÜ MÜ? — ERİŞİME KAPALI KOVANIN TEK KARAR NOKTASI.
 *
 * Kurum doğrulama belgeleri (`organization_document`, `claim_document`) gerçek
 * kimlik belgesi taşır ve ürün görselleriyle AYNI kovada duramaz: o kovanın
 * public taban adresi (`STORAGE_PUBLIC_BASE_URL`, eski adı `R2_PUBLIC_BASE_URL`)
 * imzasız okunabilir, yani imza
 * kapı değil süs olurdu. Karar `MEDIA_RULES.documentKinds`ten TÜRETİLİR —
 * çağıran yerlerde elle liste yazılmaz, yeni bir belge türü eklendiğinde
 * yalıtım kendiliğinden kapsar.
 */
export function isDocumentMediaKind(kind) {
    return MEDIA_RULES.documentKinds.includes(kind);
}
/**
 * Depolama anahtarı belge kovasına mı ait? Anahtar biçimi
 * `<kind>/<userId>/<uuid>.<uzanti>` (türevlerde `.<variant>.webp` eklenir):
 * tür HER ZAMAN ilk segmenttir. Kova seçimi ve public URL yasağı bu tek
 * fonksiyondan akar; anahtarı üreten yer ile okuyan yer ayrışamaz.
 *
 * GİRDİ BOŞ OLABİLİR ve bu TİPTE YAZILIDIR (e2e'de ölçüldü): `media_assets.variants`
 * ham JSONB'dir, tipin söz verdiği üç türevi taşımayabilir ve `variants.og`
 * çalışma zamanında `undefined` gelebiliyor. Fonksiyon burada FIRLATSAYDI, bir
 * fikstür kusuru marka yamasını 500'e düşürürdü — yalıtım kararı ise
 * değişmez: boş anahtar belge DEĞİLDİR, public yolu zaten `undefined` üretir
 * ve o ayrı bir kusurdur (raporlandı).
 */
export function isDocumentStorageKey(storageKey) {
    return isDocumentMediaKind((storageKey ?? '').split('/')[0] ?? '');
}
/** Tür bazlı medya kuralı: belge türleri PDF/5MB, görseller mevcut kural. */
export function rulesForMediaKind(kind) {
    if (isDocumentMediaKind(kind)) {
        return {
            allowedMimeTypes: MEDIA_RULES.documentMimeTypes,
            maxBytes: MEDIA_RULES.documentMaxBytes,
        };
    }
    return { allowedMimeTypes: MEDIA_RULES.allowedMimeTypes, maxBytes: MEDIA_RULES.maxBytes };
}
/**
 * İSTEMCİ FORM TASLAĞININ ÖMRÜ (elle test 3 · defter §15; 15.10.2026'da ortak pakete taşındı).
 *
 * Web etkinlik sihirbazı taslağı tarayıcıda bu süre tutar ve taslak, yüklenmiş ama henüz
 * hiçbir kayda bağlanmamış bir görselin kimliğini taşır (`Draft.coverMediaId`). Sunucunun
 * sahipsiz yükleme süpürücüsü (`ORPHAN_UPLOAD_TTL_MS`, `upload-ttl.ts`) bu süreden UZUN olmak
 * zorundadır: kısa olsaydı diriltilen taslağın kapağı depodan silinmiş olurdu. İki taraf
 * bu tek sabitten türer; metin "bir hafta" der (`form-draft.spec.ts` ikisini kilitler).
 */
export const FORM_DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=limits.js.map